import React from 'react';
import {MainHeading, SellerCard} from "../index";
import {Grid} from "@material-ui/core";
import {alertScopeOption} from "../../environment";

function RelatedProducts(props) {
  const {data} = props;
   const onSellerItemClick = (index, item) => {
    console.log(" index");
    props.history.push({
      pathname: "/detail",
      state: {product: item},
    });
  };
  return (
    <Grid container  className='mt-20 pr-20 pb-20 pt-0 pl-0 mb-50' direction='column' style={{backgroundColor: '#FFF',}}>
      <MainHeading title={'related product'}/>
      <div className='display-flex flex-wrap p-0'>
        {data.map((item, index) => {
          return (<SellerCard key={index} data={item} onClick={(event) => onSellerItemClick(index, item)}/>)
        })}
      </div>
    </Grid>
  );
}

export default RelatedProducts;
// username: admin@admin.com
// password: 1234567
